import { hseSummaryOptions } from "@dashboard/api/queryApi";
import { useSelectedCustomer } from "@dashboard/contexts/selectedCustomerContext";
import { useQuery } from "@tanstack/react-query";

export function useHseSummary(enabled = true) {
    const { selectedCustomerId } = useSelectedCustomer();

    return useQuery({ ...hseSummaryOptions(selectedCustomerId), enabled });
}
